import { JsonObject, JsonProperty } from "json2typescript";

@JsonObject("AbbreviationItem")
export class AbbreviationItem {
    @JsonProperty("name", String)
    public name: string  = "";

    @JsonProperty("name_abbr", String)
    public name_abbr: string = "";
}


// WEBPACK FOOTER //
// ./src/models/AbbreviationItem.ts